"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.Resize = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _BaseModule2 = require("./BaseModule");
/*
no-invalid-this: 'off' is justified because the way this object is created
is a bit different than a standard object.  this is essentially a plugin to quill,
so it needs it's own standardized API to create/destroy, etc.
*/
/* eslint no-invalid-this: 'off' */
var Resize = exports.Resize = /*#__PURE__*/function (_BaseModule) {
  (0, _inheritsLoose2.default)(Resize, _BaseModule);
  function Resize() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BaseModule.call.apply(_BaseModule, [this].concat(args)) || this;
    _this.onCreate = function () {
      // track resize handles
      _this.boxes = [];

      // make the handles a little bigger on mobile devices
      if (navigator.maxTouchPoints > 2) {
        _this.options.handleStyles.width = '30px';
        _this.options.handleStyles.height = '30px';
      }

      // add 4 resize handles
      _this.addBox('nwse-resize'); // top left
      _this.addBox('nesw-resize'); // top right
      _this.addBox('nwse-resize'); // bottom right
      _this.addBox('nesw-resize'); // bottom left

      _this.positionBoxes();

      // add touch-action: none to the body so that nothing weirdly moves
      // we can't do this in mousedown because
      // https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action
      // says: Note: After a gesture starts, changes to touch-action will
      // not have any impact on the behavior of the current gesture.
      _this.touchAction('none');
    };
    _this.onDestroy = function () {
      // add touch-action: auto to the body so that everything moves again
      _this.touchAction('auto');
      // reset drag handle cursors
      _this.setCursor('');
    };
    _this.positionBoxes = function () {
      var handleXOffset = -parseFloat(_this.options.handleStyles.width) / 2 + "px";
      var handleYOffset = -parseFloat(_this.options.handleStyles.height) / 2 + "px";

      // set the top and left for each drag handle
      [{
        left: handleXOffset,
        top: handleYOffset
      },
      // top left
      {
        right: handleXOffset,
        top: handleYOffset
      },
      // top right
      {
        right: handleXOffset,
        bottom: handleYOffset
      },
      // bottom right
      {
        left: handleXOffset,
        bottom: handleYOffset
      } // bottom left
      ].forEach(function (pos, idx) {
        Object.assign(_this.boxes[idx].style, pos);
      });
    };
    _this.addBox = function (cursor) {
      // create div element for resize handle
      var box = document.createElement('div');

      // Star with the specified styles
      Object.assign(box.style, _this.options.handleStyles);
      box.style.cursor = cursor;

      // Set the width/height to use 'px'
      box.style.width = _this.options.handleStyles.width + "px";
      box.style.height = _this.options.handleStyles.height + "px";

      // listen for mousedown on each box
      box.addEventListener('mousedown', _this.handleMousedown, false);
      box.addEventListener('touchstart', _this.handleMousedown, false);
      // add drag handle to document
      _this.overlay.appendChild(box);
      // keep track of drag handle
      _this.boxes.push(box);
    };
    _this.handleMousedown = function (evt) {
      // note which box
      _this.dragBox = evt.target;
      // note starting mousedown position
      _this.dragStartX = 'touches' in evt ? evt.touches[0].clientX : evt.clientX;
      // store the width before the drag
      _this.preDragWidth = _this.img.width || _this.img.naturalWidth;
      // set the proper cursor everywhere
      _this.setCursor(_this.dragBox.style.cursor);
      // listen for movement and mouseup
      document.addEventListener('mousemove', _this.handleDrag, false);
      document.addEventListener('mouseup', _this.handleMouseup, false);
      document.addEventListener('touchmove', _this.handleDrag, false);
      document.addEventListener('touchend', _this.handleMouseup, false);
    };
    _this.handleMouseup = function () {
      // reset cursor everywhere
      _this.setCursor('');
      // stop listening for movement and mouseup
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleMouseup);
      document.removeEventListener('touchmove', _this.handleDrag);
      document.removeEventListener('touchend', _this.handleMouseup);
    };
    _this.handleDrag = function (evt) {
      if (!_this.img) {
        // image not set yet
        return;
      }
      // update image size
      // const deltaX = evt.clientX - this.dragStartX;
      var deltaX = ('touches' in evt ? evt.touches[0].clientX : evt.clientX) - _this.dragStartX;
      if (_this.dragBox === _this.boxes[0] || _this.dragBox === _this.boxes[3]) {
        // left-side resize handler; dragging right shrinks image
        _this.img.width = Math.round(_this.preDragWidth - deltaX);
      } else {
        // right-side resize handler; dragging right enlarges image
        _this.img.width = Math.round(_this.preDragWidth + deltaX);
      }
      _this.requestUpdate();
    };
    _this.setCursor = function (value) {
      [document.body, _this.img].forEach(function (el) {
        el.style.cursor = value; // eslint-disable-line no-param-reassign
      });
    };
    // value must be either 'none' or 'auto'
    _this.touchAction = function (value) {
      document.body.style.touchAction = value;
      document.body.style.webkitTouchAction = value;
      document.body.style.webkitTouchCallout = value;
      document.body.style.webkitUserSelect = value;
      document.body.style.khtmlUserSelect = value;
      document.body.style.mozUserSelect = value;
      document.body.style.msUserSelect = value;
      document.body.style.userSelect = value;
    };
    return _this;
  }
  return Resize;
}(_BaseModule2.BaseModule);